import { getAppBaseUrl } from './cdnConfigUtils';

/**
 * Login / home app URL for auth error and not-found screens.
 * Custom portal domains stay on the same origin; Structured hosts use build-time apiConfig.appPath.
 */
export const resolveAppBaseUrlFromHostname = (hostname: string): string => {
  const host = hostname.toLowerCase();
  const isLocal = host === 'localhost' || host === '127.0.0.1';
  const isStructured =
    host === 'structured.ai' || host.endsWith('.structured.ai');

  if (isLocal) {
    return typeof window !== 'undefined'
      ? window.location.origin
      : getAppBaseUrl();
  }

  if (!isStructured) {
    return typeof window !== 'undefined'
      ? window.location.origin
      : getAppBaseUrl();
  }

  return getAppBaseUrl();
};
